// nativeShare — open the OS share sheet when available, otherwise copy the link.
// Returns 'shared' | 'copied' | 'cancelled' so callers can toast appropriately.
export async function nativeShare({ title, text, url }) {
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return 'shared';
    } catch (err) {
      // User dismissed the sheet — not an error worth surfacing.
      if (err && err.name === 'AbortError') return 'cancelled';
      // Fall through to copy on any other failure.
    }
  }
  try {
    const payload = text ? `${text}\n${url}` : url;
    await navigator.clipboard.writeText(payload);
    return 'copied';
  } catch {
    return 'cancelled';
  }
}
